import { writable } from 'svelte/store';

let pkgBrief = writable([]);
let dropdownAddElementIsActive = writable(false);
let outputFileName = writable('');
let modalIsActive = writable(false);

export { pkgBrief, dropdownAddElementIsActive, outputFileName, modalIsActive };